import { activities } from './activity';
import { advocateAccept, apiIntegrate, corporateConfirm, discussionReply, questions, twitterFollow, twitterPost } from './stage';
export var challenges = [{
  __typename: 'Challenge',
  id: '23456',
  activities: [activities[0]],
  minimumAvailablePoints: 123,
  maximumAvailablePoints: 123,
  banner: {
    id: 'a6fe1af4-7fe6-4048-b7be-1acf60147f00',
    blurhash: 'LOHBe--o0LOAnOtSX89aiwM|NGR-'
  },
  category: {
    id: '1',
    name: 'Animal'
  },
  description: 'Leverage agile frameworks to provide a robust synopsis for high level overviews. Iterative approaches' + 'to corporate strategy foster collaborative thinking to further the overall value proposition. Organically' + 'grow the holistic world view of disruptive innovation via workplace diversity and empowerment.  Bring to ' + 'the table win-win survival strategies to ensure proactive domination. At the end of the day, going forward, ' + 'a new normal that has evolved from generation X is on the runway heading towards a streamlined cloud solution.' + ' User generated content in real-time will have multiple touchpoints for offshoring.',
  expiresAt: '2022-10-01T14:30:44Z',
  firstStage: corporateConfirm,
  headline: 'Apiaries and Honey: Learn All About Bees',
  inProgress: true,
  multiComplete: false,
  unseen: true,
  hideBannerImage: false,
  remainingCompletionCount: null,
  memberRemainingCompletionCount: null,
  totalStages: 2,
  savedForLater: false,
  availableForCompletion: true,
  prospect: null
}, {
  __typename: 'Challenge',
  id: '8123',
  activities: [activities[0]],
  minimumAvailablePoints: 10,
  maximumAvailablePoints: 10,
  name: '$5 Donation: Hollaback!',
  banner: {
    id: 'b2a93f3a-5b0f-4b26-b79b-de74241fa000',
    blurhash: 'LE9jl.n10f9ttTROt7t79sX9$gxb'
  },
  category: {
    id: '2',
    name: 'Recipe'
  },
  description: 'Some description',
  expiresAt: '2021-10-05T14:30:44Z',
  firstStage: discussionReply,
  headline: 'Paella',
  inProgress: false,
  multiComplete: true,
  unseen: true,
  hideBannerImage: false,
  remainingCompletionCount: 1,
  memberRemainingCompletionCount: null,
  totalStages: 1,
  savedForLater: false,
  availableForCompletion: true,
  prospect: null
}, {
  __typename: 'Challenge',
  id: '16789',
  activities: null,
  minimumAvailablePoints: 500,
  maximumAvailablePoints: 500,
  banner: {
    id: 'fc4514e6-70ca-46fe-e193-a966c926e300',
    blurhash: 'LIByHW-pEREObHNHWUWC0gad-SoJ'
  },
  category: {
    id: '3',
    name: 'Album'
  },
  description: 'Some description',
  expiresAt: '2022-10-01T14:30:44Z',
  firstStage: advocateAccept,
  headline: 'Live From Space',
  inProgress: false,
  multiComplete: true,
  unseen: false,
  hideBannerImage: false,
  remainingCompletionCount: null,
  memberRemainingCompletionCount: 1,
  totalStages: 4,
  savedForLater: false,
  availableForCompletion: true,
  prospect: null
}, {
  __typename: 'Challenge',
  id: '67812390',
  activities: null,
  minimumAvailablePoints: 23,
  maximumAvailablePoints: 23,
  banner: {
    id: 'ac858154-3164-46a9-a699-707b28e01000',
    blurhash: 'LCDvTR%MD%4:?wo#RORO_NIoxBRO'
  },
  category: {
    id: '3',
    name: 'Album'
  },
  description: 'Some description',
  expiresAt: '2022-10-01T14:30:44Z',
  firstStage: twitterFollow,
  headline: "The Hunt for Gold: A Leprechuan's Quest",
  inProgress: false,
  unseen: false,
  hideBannerImage: false,
  multiComplete: true,
  remainingCompletionCount: null,
  memberRemainingCompletionCount: 0,
  totalStages: 5,
  savedForLater: false,
  availableForCompletion: true,
  prospect: null
}, {
  __typename: 'Challenge',
  id: '3456',
  activities: [activities[2]],
  minimumAvailablePoints: 32,
  maximumAvailablePoints: 32,
  banner: {
    id: 'b2a93f3a-5b0f-4b26-b79b-de74241fa000',
    blurhash: 'LE9jl.n10f9ttTROt7t79sX9$gxb'
  },
  category: {
    id: '1',
    name: 'Animal'
  },
  description: 'Some description',
  expiresAt: '2022-10-01T14:30:44Z',
  firstStage: apiIntegrate,
  headline: 'Lizard',
  inProgress: false,
  multiComplete: false,
  unseen: false,
  hideBannerImage: false,
  remainingCompletionCount: 0,
  memberRemainingCompletionCount: null,
  totalStages: 1,
  savedForLater: false,
  availableForCompletion: true,
  prospect: null
}, {
  __typename: 'Challenge',
  id: '1238567',
  activities: null,
  minimumAvailablePoints: 123,
  maximumAvailablePoints: 123,
  banner: {
    id: '43b65c75-3655-4c6d-358a-e6ea965eb300',
    blurhash: 'LQIV;{o15;R-}rjZEij]buxan%xZ'
  },
  category: {
    id: '2',
    name: 'Recipe'
  },
  description: 'Some description',
  expiresAt: '2022-10-01T14:30:44Z',
  firstStage: twitterPost,
  headline: 'Paella',
  inProgress: false,
  unseen: false,
  hideBannerImage: false,
  multiComplete: true,
  remainingCompletionCount: 0,
  memberRemainingCompletionCount: 1,
  totalStages: 2,
  savedForLater: false,
  availableForCompletion: true,
  prospect: null
}, {
  __typename: 'Challenge',
  id: '321',
  activities: [activities[0]],
  minimumAvailablePoints: 123,
  maximumAvailablePoints: 125,
  banner: {
    id: '43b65c75-3655-4c6d-358a-e6ea965eb300',
    blurhash: 'LQIV;{o15;R-}rjZEij]buxan%xZ'
  },
  category: {
    id: '2',
    name: 'Recipe'
  },
  description: 'Some description',
  expiresAt: '2022-10-01T14:30:44Z',
  firstStage: questions,
  headline: 'In progress Questions',
  inProgress: false,
  multiComplete: false,
  unseen: false,
  hideBannerImage: false,
  remainingCompletionCount: null,
  memberRemainingCompletionCount: null,
  totalStages: 3,
  savedForLater: false,
  availableForCompletion: true,
  prospect: null
}, {
  __typename: 'Challenge',
  id: '333',
  activities: [activities[0]],
  minimumAvailablePoints: 123,
  maximumAvailablePoints: 200,
  banner: {
    id: '43b65c75-3655-4c6d-358a-e6ea965eb300',
    blurhash: 'LQIV;{o15;R-}rjZEij]buxan%xZ'
  },
  category: {
    id: '2',
    name: 'Recipe'
  },
  description: 'Some description',
  expiresAt: '2022-10-01T14:30:44Z',
  firstStage: questions,
  headline: 'In progress Questions',
  inProgress: false,
  multiComplete: false,
  unseen: false,
  hideBannerImage: false,
  remainingCompletionCount: 0,
  memberRemainingCompletionCount: null,
  totalStages: 3,
  savedForLater: false,
  availableForCompletion: true,
  prospect: null
}, {
  __typename: 'Challenge',
  id: '124',
  activities: null,
  minimumAvailablePoints: 5,
  maximumAvailablePoints: 5,
  banner: null,
  category: null,
  description: 'Some description',
  expiresAt: '2022-10-01T14:30:44Z',
  firstStage: questions,
  headline: 'The Best Stage',
  inProgress: false,
  multiComplete: false,
  unseen: false,
  hideBannerImage: false,
  remainingCompletionCount: null,
  memberRemainingCompletionCount: null,
  totalStages: 1,
  savedForLater: false,
  availableForCompletion: true,
  prospect: null
}];